import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { useAppBridge } from "@shopify/app-bridge-react";
import { Redirect } from "@shopify/app-bridge/actions";
// @ts-ignore
import { useNavigate } from "react-router-dom";
import { gql, useApolloClient, useMutation } from '@apollo/client';
import { Button, ButtonVariant, primaryActionLoadingVar, startPrimaryAction, completePrimaryAction } from '@withfriendsco/wf-components';
const UPDATE_REDEMPTION_BENEFIT = gql `
  mutation SaveRedemptionBenefit($id: ID!, $benefit: BenefitInput!) {
    updateBenefit(id: $id, benefit: $benefit) {
      id
      name
      ... on RedemptionBenefit {
        delivery
        perPeriod
        shippingNotesInstructions
      }
    }
  }
`;
const GET_REDEMPTION_BENEFIT = gql `
  query GetRedemptionBenefit($id: ID!) {
    benefit(id: $id) {
      __typename
      id
      name
      ... on RedemptionBenefit {
        delivery
        perPeriod
        shippingNotesInstructions
      }
    }
  }
`;
const SaveRedemptionBenefit = ({ id, fromOnboarding = true }) => {
    const client = useApolloClient();
    const [mutate] = useMutation(UPDATE_REDEMPTION_BENEFIT);
    const [validationError, setValidationError] = useState(null);
    const redemption = useMemo(() => {
        var _a;
        try {
            const data = client.readQuery({ query: GET_REDEMPTION_BENEFIT, variables: { id } });
            return ((_a = data === null || data === void 0 ? void 0 : data.benefit) === null || _a === void 0 ? void 0 : _a.__typename) === 'RedemptionBenefit' ? data.benefit : null;
        }
        catch (_b) {
            return null;
        }
    }, [client, id]);
    const isInvalid = useMemo(() => {
        var _a;
        if (!redemption)
            return true;
        const name = (redemption.name || '').trim();
        const per = Number((_a = redemption.perPeriod) !== null && _a !== void 0 ? _a : 1);
        return name.length === 0 || !Number.isFinite(per) || per < 1;
    }, [redemption]);
    const loading = primaryActionLoadingVar();
    // TODO - can't seem to abstract this out without React crashing, so we gotta copy and paste it into any relevant file
    let app, redirect = null;
    let navigate = useNavigate();
    let isEmbedded = false;
    try {
        app = useAppBridge();
        redirect = Redirect.create(app);
        isEmbedded = true;
    }
    catch (e) { }
    const VisitLink = (url) => {
        (redirect ?
            redirect.dispatch(Redirect.Action.APP, url) :
            navigate(url));
    };
    const onSave = async () => {
        var _a;
        startPrimaryAction();
        const data = client.readQuery({ query: GET_REDEMPTION_BENEFIT, variables: { id } });
        const redemption = data === null || data === void 0 ? void 0 : data.benefit;
        if (!redemption || redemption.__typename !== 'RedemptionBenefit') {
            completePrimaryAction();
            return;
        }
        const name = (redemption.name || '').trim();
        const per = Number((_a = redemption.perPeriod) !== null && _a !== void 0 ? _a : 1);
        if (name.length === 0) {
            setValidationError('Benefit name cannot be blank.');
            completePrimaryAction();
            return;
        }
        if (!Number.isFinite(per) || per < 1) {
            setValidationError('Redemptions per period must be at least 1.');
            completePrimaryAction();
            return;
        }
        setValidationError(null);
        await mutate({
            variables: {
                id,
                benefit: {
                    redemption: {
                        name: redemption.name,
                        delivery: redemption.delivery,
                        perPeriod: redemption.perPeriod,
                        shippingNotesInstructions: redemption.shippingNotesInstructions || null,
                    },
                },
            },
        });
        completePrimaryAction();
        const element = document.querySelector(`.wf-change-redemption-benefit-${id}`);
        console.log(element);
        if (element) {
            element.click();
        }
        if (fromOnboarding) {
            VisitLink("/memberships");
        }
    };
    return (_jsxs("div", { className: "w-full max-w-lg px-4", children: [_jsx("div", { className: "my-4 border-t-2 border-wfGray-300" }), validationError && (_jsx("div", { className: "text-wfRed-600 text-sm mb-2", children: validationError })), _jsx(Button, { className: "my-4", variant: ButtonVariant.Salmon, disabled: loading, onClick: onSave, children: "Save Redemption Benefit" })] }));
};
export default SaveRedemptionBenefit;
